export const GREY = '#d2d5da'
export const DARK_GREY = '#808080'
export const BLUE = '#06739c'
export const NAVY = '#181c52'
export const WHITE = '#ffffff'
export const RED = '#f92b00'
export const BLACK = '#373a36'
export const TEAL = '#14a098'
